var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible && _vm.message)?_c('div',{attrs:{"id":"toast"}},[_c('div',{staticClass:"inner"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }